module.exports = __webpack_public_path__ + "images/d57f69e136907ddd61e98df2dce1849c.svg";